import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { WishlistService } from '../../../services/raintree/Transmission/wishlist.service';
import { ToastrService } from 'ngx-toastr';
import { DpSuccessMessageComponent } from '../../../common-component/dp-success-message/dp-success-message.component';
import { ActivatedRoute } from '@angular/router';
import { LoaderComponent } from '../../../common-component/loader/loader.component';

@Component({
  selector: 'app-edit-wishlist-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, MatDialogModule, LoaderComponent],
  templateUrl: './edit-wishlist-dialog.component.html',
  styleUrl: './edit-wishlist-dialog.component.scss',
})
export class EditWishlistDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditWishlistDialogComponent>,
    private _wishlistService: WishlistService,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private _activatedRoute: ActivatedRoute
  ) { }
  queryParams: any;
  isLoading: boolean = false
  ngOnInit() {
    this.wishlistName.setValue(this.data.name);
    this.queryParams = { ...this._activatedRoute.snapshot.queryParams };
  }

  wishlistName = new FormControl('');

  restrictWishlistNameInput(event: KeyboardEvent): void {
    const input = event.key;
    const pattern = /^[A-Za-z0-9\-_()\s]+$/;
    if (!pattern.test(input)) {
      event.preventDefault();
    }
  }

  editWishlist() {
    let name: any = this.wishlistName.value;
    if (name.length == 0) this.toaster.error('Enter wishlist name');
    else if (name == this.data.name) {
      this.dialogRef.close();
    } else {
      this.isLoading = true
      if (this.data.type === 'centralizedReach' || this.data.type === 'Reach') {
        this._wishlistService
          .editReachWishList(this.data.id, { name: name })
          .subscribe({
            next: (response: any) => {
              if (!response.error)
                this.dialog.open(DpSuccessMessageComponent, {
                  panelClass: 'common-pannel-dialog-container',
                  data: {
                    mainHeading: `Wishlist name has been succesfully edited to '${this.wishlistName.value}'`,
                    subHeading:
                      'You can access all wish-lists from the ‘My wishlist’ menu on the Reach Defaulter page ',
                    buttonValue: 'Done',
                  },
                });
              this.isLoading = false
              this.dialogRef.close(true);
            },
            error: (error) => {
              this.isLoading = false
              this.toaster.error(error);
            },
          });
      } else if (
        this.data.type === 'centralizedFd' ||
        this.data.type === 'fd'
      ) {
        this.isLoading = true

        this._wishlistService
          .editWishList(this.data.id, { title: name, listType: 'PHL' })
          .subscribe({
            next: (response: any) => {
              if (!response.error)
                this.dialog.open(DpSuccessMessageComponent, {
                  panelClass: 'common-pannel-dialog-container',
                  data: {
                    mainHeading: `Wishlist name has been succesfully edited to '${this.wishlistName.value}'`,
                    subHeading:
                      'You can access all wish-lists from the ‘My wishlist’ menu on the Find Details page ',
                    buttonValue: 'Done',
                  },
                });
              this.isLoading = false
              this.dialogRef.close(true);
            },
            error: (error) => {
              this.isLoading = false
              this.toaster.error(error);
            },
          });
      } else if (
        this.data.type === 'centralizedPm' ||
        this.data.type === 'pm'
      ) {
        this.isLoading = true

        this._wishlistService
          .UpdateWishlist({
            oldWishlistId: String(this.data.id),
            uiState: this.queryParams['state'],
            uiDistrict: this.queryParams['district'],
            renameString: name.trim(),
          })
          .subscribe({
            next: (response: any) => {
              if (!response.error)
                this.dialog.open(DpSuccessMessageComponent, {
                  panelClass: 'common-pannel-dialog-container',
                  data: {
                    mainHeading: `Wishlist name has been succesfully edited to '${this.wishlistName.value}'`,
                    subHeading:
                      'You can access all wish-lists from the ‘My wishlist’ menu on the Print and Monitor page ',
                    buttonValue: 'Done',
                  },
                });
              this.isLoading = false
              this.dialogRef.close(true);
            },
            error: (error) => {
              this.isLoading = false
              this.toaster.error(error);
            },
          });
      }
    }
  }
}
